import { SidebarProvider } from '@goaltree/ui/components/sidebar'
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'sidebar_open'

function readStored(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v === null ? true : v === '1'
  } catch {
    return true
  }
}

export function PersistentSidebarProvider({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const [open, setOpen] = useState(readStored)

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, open ? '1' : '0')
    } catch {}
  }, [open])

  return (
    <SidebarProvider open={open} onOpenChange={setOpen} className={className}>
      {children}
    </SidebarProvider>
  )
}
